export enum ListMode {
  Grid = 'grid',
  List = 'list'
}

export interface ListModeSwitchProps {
  mode?: ListMode
}
